import { render, staticRenderFns } from "./KnowledgeBaseDialogNewDoc.vue?vue&type=template&id=445cf555&scoped=true&lang=pug&"
import script from "./KnowledgeBaseDialogNewDoc.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseDialogNewDoc.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseDialogNewDoc.vue?vue&type=style&index=0&id=445cf555&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445cf555",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCard,VMenu,VRow,VTextField,VTextarea,VTreeview})
